import { renderDefaultValueCols } from "./renderDefaultValueCols";

type TableValueOptions = {
  showZeroForEmpty?: boolean;
  showZeroForNull?: boolean;
};

export const renderTableValue = (value: any, options: TableValueOptions = {}) => {
  const { showZeroForEmpty = false, showZeroForNull = false } = options;
  
  const result = renderDefaultValueCols(value);
  
  if (result === '-' && showZeroForEmpty) {
    return '0';
  }
  
  if ((value === null || value === undefined) && showZeroForNull) {
    return '0';
  }
  
  return result;
}

export const TABLE_VALUE_CONFIGS = {
  NUMERIC: { showZeroForEmpty: true },
  TEXT: { showZeroForEmpty: false },
  COUNT: { showZeroForEmpty: true, showZeroForNull: true },
  PRESERVE_DASH: { showZeroForEmpty: false }
} as const;

export const renderNumericColumn = (value: any) => renderTableValue(value, TABLE_VALUE_CONFIGS.NUMERIC);
export const renderTextColumn = (value: any) => renderTableValue(value, TABLE_VALUE_CONFIGS.TEXT);
export const renderCountColumn = (value: any) => renderTableValue(value, TABLE_VALUE_CONFIGS.COUNT);